import clsx from 'clsx';
import { Checkbox } from '@headlessui/react';

import Typography from '~/shared/components/Typography';
import CheckIcon from '~/shared/assets/icons/check.svg';

import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'volumeId',
  groupLabel: 'Volume ID',
  mustTypeFirstMessage: 'Start typing volume id',
  defaultQuery: 'vol-',
  debounceMs: 200,
  logPrefix: '[VolumeIdFilter]',
  // Volume ID is the one section that does not use the shared tag row: ids are long enough
  // that a Tag pill wraps badly, so it renders a plain checkbox + label instead.
  renderOption: ({ option, isSelected, isFocused, onSelect }) => (
    <div
      key={option.id}
      className={clsx(
        'p-3 my-1 rounded-lg transition-colors flex items-center min-w-0',
        isFocused && 'bg-primary-20'
      )}
      onClick={() => onSelect(option)}
    >
      <div className="mr-2 shrink-0">
        <Checkbox
          checked={isSelected}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(option);
          }}
          className={clsx(
            'group block size-5 p-[4px] rounded-md border border-gray-400 bg-white data-checked:bg-primary-500 ring:0 active:ring-primary-300 focus:ring-primary-500 cursor-pointer',
            isFocused && 'border-primary-400'
          )}
        >
          <CheckIcon className="text-white stroke-2 size-2.5 opacity-0 group-data-checked:opacity-100 transition duration-200 ease-in-out" />
        </Checkbox>
      </div>
      <Typography
        variant="p3-reg"
        truncate
        className={clsx('text-primary-900 cursor-pointer min-w-0', isSelected ? 'font-500' : 'font-400')}
      >
        {option.name}
      </Typography>
    </div>
  ),
});
